// tslint:disable
export var EnrollmentJobType;
(function (EnrollmentJobType) {
    // QP Enrollment Feed
    EnrollmentJobType[EnrollmentJobType["EnrollmentFeed"] = 1] = "EnrollmentFeed";
})(EnrollmentJobType || (EnrollmentJobType = {}));
EnrollmentJobType['ENROLLMENTFEED'] = 1;
//# sourceMappingURL=EnrollmentJobType.js.map